import { useEffect } from 'react';
import { useRoutePath } from 'react-static';
import { addUKPixelConsentListener, trackUKPageView } from '../../services/UKMarketingPixels.service';

export const UKMarketingPixels = () => {
  const routePath = useRoutePath('');

  useEffect(() => addUKPixelConsentListener(), []);

  useEffect(() => {
    trackUKPageView();
  }, [routePath]);

  return null;
};
